import {Layout} from '@eitje/web_components'

export const Logo = () => {
	return (
		<Layout to="/" margin="- 16 - 24">
			<img src="/brand/logo-with-text.png" height={34} />
		</Layout>
	)
}
